import React, { useState, useEffect } from "react";
import Search from "../../components/Search";
import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { setsidebarOpen } from "../../redux/actions/styles";
import TooltipPrimary from "../../components/tooltips/TooltipPrimary";
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import { useLocation, useNavigate } from "react-router-dom";

const Navbar = (props) => {
  const { setliftUpActive } = props;

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const AC = bindActionCreators({ setsidebarOpen }, dispatch);
  const { sidebarOpen } = useSelector((state) => state.styles);
  const [navbarBg, setnavbarBg] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 50) {
        setnavbarBg(true);
      } else {
        setnavbarBg(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div
      className={`navbar ${navbarBg ? "bg-visible" : ""} ${sidebarOpen ? "sidebar-open" : ""} ${
        pathname === "/snap" ? "navbar-hide" : ""
      }`}
    >
      <div className="sidebar-btn" onClick={() => AC.setsidebarOpen(true)}>
        <i className="fas fa-chevron-right"></i>
      </div>
      <Search onFocus={() => navigate("/search")} className={pathname.includes("/search") ? "search-hide" : ""} />
      <div className="right">
        <TooltipPrimary className="bell" text="Notifications" onClick={() => setliftUpActive(true)}>
          <NotificationsRoundedIcon />
          <div className="indicator" />
        </TooltipPrimary>
        <TooltipPrimary className="icon" text="Settings" onClick={() => setliftUpActive(true)}>
          <TuneRoundedIcon />
        </TooltipPrimary>
        <TooltipPrimary className="avatar" text="Account" onClick={() => setliftUpActive(true)}>
          <img src="https://i.pinimg.com/564x/25/17/51/2517513d26564ae0262292e013f3afc2.jpg" alt="dp" />
          <p>John Doe</p>
        </TooltipPrimary>
      </div>
      <div className="bg-dark" onClick={() => AC.setsidebarOpen(false)} />
    </div>
  );
};

export default Navbar;
